import { MenuProps } from 'antd'
import InnerNav from 'components/InnerNav/InnerNav'
import { t } from 'i18next'
import React, { Fragment, useEffect, useState } from 'react'
import Security from './Security'
import Logs from '../Logs/Logs'
import AuditConfiguratorNav from '../AuditConfigurator/AuditConfiguratorNav/AuditConfiguratorNav'
import FileEncryption from '../FileEncryption/FileEncryption'
import KillSwitch from '../KillSwitch/KillSwitch'
import { SecurityNavSetting } from 'utils/enums'

interface SecurityNavProps {
  currentAppKey: any[]
  updateCurrentAppKey: () => void
}

const SecurityNav: React.FC<SecurityNavProps> = ({ currentAppKey, updateCurrentAppKey }) => {
  const [appTabFilter, setAppTabFilter] = useState(SecurityNavSetting.GENERAL)
  const [selectedComponent, setSelectedComponent] = useState<JSX.Element | null>(null)

  const onTabClick: MenuProps['onClick'] = (e) => {
    setAppTabFilter(e.key as SecurityNavSetting)
  }

  useEffect(() => {
    switch (appTabFilter) {
      case SecurityNavSetting.GENERAL:
        setSelectedComponent(
          <Security currentAppKey={currentAppKey} updateCurrentAppKey={updateCurrentAppKey} />
        )
        break
      case SecurityNavSetting.LOGS:
        setSelectedComponent(<Logs />)
        break
      case SecurityNavSetting.AUDIT_CONFIG:
        setSelectedComponent(
          <AuditConfiguratorNav currentAppKey={currentAppKey} updateCurrentAppKey={updateCurrentAppKey} />
        )
        break
      case SecurityNavSetting.FILE_ENCRYPTION:
        setSelectedComponent(<FileEncryption />)
        break
      case SecurityNavSetting.KILL_SWITCH:
        setSelectedComponent(<KillSwitch />)
        break
      default:
        setSelectedComponent(<div></div>)
    }
  }, [appTabFilter, currentAppKey, updateCurrentAppKey])

  return (
    <>
      <div className="app-setting-container ">
        <div className="app-setting-nav">
          <InnerNav
            theme="light"
            onTabClick={onTabClick}
            selected={appTabFilter}
            menu={[
              { label: t('generalSecurityLabel'), key: SecurityNavSetting.GENERAL },
              { label: t('logsLabel'), key: SecurityNavSetting.LOGS },
              { label: t('auditLogsConfiguratorLabel'), key: SecurityNavSetting.AUDIT_CONFIG },
              { label: t('fileEncryptionSettingLabel'), key: SecurityNavSetting.FILE_ENCRYPTION },
              { label: t('killSwitchLabel'), key: SecurityNavSetting.KILL_SWITCH },
            ]}
          />
        </div>
      </div>
      {selectedComponent}
    </>
  )
}

export default SecurityNav